<template>
  <div id="Tab7">
    <div class="tag-badge-info">
      <span class="tag-badge-title-info pb-2 pl-3">Documentos</span>
    </div>
    <div class="dropdown-divider mt-0 pb-2 ml-3" />
    <div class="container-table-striped">
      <div class="table-hover">
        <span class="text-danger">
          {{
            validateDocuments()
              ? ''
              : 'El documento de tipo Minuta de Referido de Evaluación AT es requerido estar anejado'
          }}
        </span>
        <table class="table content-table-striped table-h">
          <thead>
            <tr class="row global-thead-dark thead-property">
              <th class="col-4 pl-5 py-3">
                <span class="ml-5 bold">Nombre del Archivo</span>
              </th>
              <th class="col-4 py-3 bold">
                Tipo de Documento
              </th>
              <th class="col-2 py-3 bold">
                Requerido
              </th>
              <th class="col-2 pl-5 py-3">
                <span class="d-flex text-center" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="row">
              <td class="col-4 pl-5 py-3">
                <label v-if="fileSelect" for="file">{{ fileSelect }}</label>
                <button
                  v-if="!fileSelect"
                  v-show="!atCompletedFlag"
                  class="btn bg-light-white btn-addFile btn-anejar"
                  for="file"
                  @click="() => this.$refs.file.click()"
                >
                  <i class="fas fa-file-plus text-green pr-1" />
                  <span class="ml-2">Presione aquí para anejar</span>
                </button>
                <input
                  v-if="!fileSelect"
                  id="file"
                  ref="file"
                  type="file"
                  :disabled="atCompletedFlag"
                  style="display:none;"
                  accept="application/pdf"
                  @change="documentsUploadFilesPeiAT()"
                />
              </td>
              <td class="col-4 py-3">
                Minuta de Referido de Evaluación AT
              </td>
              <td class="col-2 py-3">
                Si
              </td>
              <td class="col-2 dropdown py-3 pr-5">
                <div v-if="fileSelect != ''">
                  <button
                    class="btn btn-dropdown-actions dropdown-toggle pt-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Acciones
                  </button>
                  <div class="dropdown-menu pb-0">
                    <a class="drop-item" href="#" @click="downloadMinuteAT()">
                      <i class="fas fa-file-download text-green pr-1" />
                      <span>Descargar</span>
                    </a>
                    <a
                      v-show="!atCompletedFlag"
                      class="drop-item"
                      href="#"
                      @click="onDeleteATDocument()"
                    >
                      <i class="fas fa-times-circle text-red pr-1" />
                      <span>Eliminar</span>
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import generalService from '@/services/pei/general';
import store from '@/store/index';
import alert from '@/mixin/alert.mixin';
import resourcesService from '@/services/resources.js';
import loading from '@/mixin/loading.mixin';
import atService from '@/services/pei/at';
import documentTypes from '@/utils/constants/documentTypes.js';
export default {
  data() {
    return {
      fileSelect: '',
      resources: [],
      ValidationTriggered: store.getters.getatValidationTriggered,
    };
  },
  mixins: [loading, alert],
  methods: {
    async documentsUploadFilesPeiAT() {
      if (this.$refs.file.files[0].type == 'application/pdf') {
        let atServiceId = this.atServiceId;

        if (this.atServiceId === 0) {
          const createdAtServiceId = await atService.createAtService(
            store.getters.SelectedPei
          );

          if (createdAtServiceId > 0) {
            store.dispatch('setSelectedAt', createdAtServiceId);
            atServiceId = createdAtServiceId;
          }
        }

        let files = new FormData();
        this.fileSelect = 'Minuta de Referido.pdf';
        files.append(
          atServiceId,
          this.$refs.file.files[0],
          this.$refs.file.files[0].name
        );

        generalService.documentsUploadFiles(files);
      }
    },
    downloadMinuteAT() {
      generalService.documentsDownloadFiles(
        store.getters.SelectedAt,
        documentTypes.MinuteReferralEvaluationAt
      );
    },
    documentsDeleteFilesPeiAT() {
      generalService.documentsDeleteFiles(store.getters.SelectedAt);
      this.fileSelect = '';
    },
    documentsLoadFilesPeiAT() {
      if (store.getters.SelectedAt != 0) {
        generalService
          .documentsLoadFiles(store.getters.SelectedAt)
          .then((response) => {
            if (response.data) {
              this.fileSelect = 'Minuta de Referido.pdf';
            } else {
              this.fileSelect = '';
            }
          });
      }
    },
    async onDeleteATDocument() {
      let answer = await this.ShowCancelModal(
        this.resources.R90005,
        this.resources.R90006,
        this.resources.R90007,
        this.resources.R90008
      );
      if (answer) {
        try {
          generalService
            .documentsDeleteFiles(store.getters.SelectedAt)
            .then((response) => {
              if (response.data) {
                this.ShowToast('', this.resources.R90009, 'success');
                this.fileSelect = '';
                this.$refs.file.value = '';
              } else {
                this.fileSelect = 'Minuta de Referido.pdf';
                this.ShowToast(
                  this.resources.R90011,
                  this.resources.R90012,
                  this.resources.R90013
                );
              }
            });
        } catch {
          this.ShowToast(
            this.resources.R90011,
            this.resources.R90012,
            this.resources.R90013
          );
        }
      }
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R90005',
        'R90006',
        'R90007',
        'R90008',
        'R90009',
        'R90011',
        'R90012',
        'R90013',
      ]);
    },
    validateDocuments() {
      if (this.ValidationTriggered.validation) {
        if (this.fileSelect == '') {
          return false;
        }
      }
      return true;
    },
    validateReadMode() {
      if (!this.atCompletedFlag) {
        return;
      }

      const tags = ['input', 'button', 'textarea', 'select'];
      tags.forEach((tagName) => {
        const nodes = document
          .getElementById('Tab7')
          .getElementsByTagName(tagName);

        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = true;
          nodes[i].tabIndex = -1;
        }
      });
    },
  },
  async created() {
    await this.loadResources();
    await this.documentsLoadFilesPeiAT();
  },
  mounted() {
    this.validateReadMode();
  },
  computed: {
    atCompletedFlag() {
      return store.getters.getAtCompleted;
    },
    atServiceId() {
      return store.getters.SelectedAt;
    },
  },
};
</script>

<style scoped>
.file-select {
  padding: 15px 15px 15px 15px;
  background-color: #fff;
  border-width: 2px;
  border-color: #f2f2f2;
  border-style: solid;
  cursor: pointer;
}

.btn-anejar {
  width: 300px;
}
</style>
